import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FJ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#FJ_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#67BFE5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FJ_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#FJ_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 10h9.655v8.333S28.845 22 24.828 22C20.81 22 20 18.333 20 18.333V10z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FJ_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 20,
      y: 10,
      width: 10,
      height: 12
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 10h9.655v8.333S28.845 22 24.828 22C20.81 22 20 18.333 20 18.333V10z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#FJ_svg__c)" }, /* @__PURE__ */ e.createElement("path", { fill: "#C3352C", d: "M20 10h9.655v3H20z" }), /* @__PURE__ */ e.createElement("path", { fill: "#C3352C", d: "M24.139 12.667h1.379V22h-1.379z" }), /* @__PURE__ */ e.createElement("path", { fill: "#C3352C", d: "M20 16.333h9.655v1.333H20z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.54 20.738c.581.82 1.054 1.14 1.389.657.235-.34.259-.68-.076-.747a5.564 5.564 0 01-.41-.573l.012-.01c.094-.092.097-.214.079-.26-.008-.061.039-.146.34-.376.274-.21.395-.406.216-.623-.094-.114-.179-.136-.445-.178l-.082-.012a1.414 1.414 0 01-.173-.036l-.186-.356a2.289 2.289 0 00-1.021.196l-.303.129a1.208 1.208 0 01-.118.046c.008-.006.02-.017.002-.017-.07 0-.146-.007-.355-.034l-.042-.005c-.603-.076-.754-.074-.852.207-.149.428.732 1.211 1.2 1.306.234.047.514.271.826.686zm.657-.59c.057 0 .1-.002.14-.012l.011-.026a.262.262 0 01-.15.039zm-2.203-1.18c-.012-.014-.015-.032-.007-.057-.002.005.004.016.016.032l-.009.026zm.06.033c.165.172.592.527.76.56.378.077.748.373 1.13.882.389.549.57.672.573.668.042-.06.06-.046.092-.02.024.02.056.046.114.046l-.195-.094c-.272-.34-.455-.598-.552-.78-.139-.26-.16-.52.072-.594.04-.172.17-.35.427-.56-.207-.034-.328-.069-.434-.152a.391.391 0 01-.148-.22c-.177.021-.339.07-.516.144l-.3.128c-.229.096-.274.116-.278.11l.004-.008c.007-.012.019-.032-.039-.032-.1 0-.183-.009-.418-.039l-.041-.005-.085-.01a1.06 1.06 0 01-.166-.024zm0 0a.122.122 0 01-.06-.032l.009-.026a.719.719 0 00.05.058zm1.98.86c.003-.003.002-.006.002-.01l-.003.01zm.159-.212h-.015l.007.001h.008zm.004 0h-.004.004z",
      fill: "#979797"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M21.655 16.11s-.477-.66-.477-.895", stroke: "#964C36" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.358 15.542s-.61-.26-.61 0M21.348 15.268s-.43-.545-.752-.545-.315.273-.315.273M21.104 14.722s-.192-.893-.499-.893c-.306 0-.306.446-.306.446M21.181 14.72s-.085-.765.31-.765",
      stroke: "#2A8E51"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M22.261 15.981s-.222-.783-.142-1.004", stroke: "#964C36" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.177 15.347s-.484-.454-.573-.209M22.261 15.086s-.216-.66-.52-.77c-.303-.11-.389.148-.389.148M22.218 14.488s.126-.904-.162-1.01c-.288-.104-.441.316-.441.316M22.292 14.513s.181-.748.552-.613",
      stroke: "#2A8E51"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.752 16.26s.317-.75.264-.98",
      stroke: "#964C36",
      strokeWidth: 0.7
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.913 15.64s.536-.39.595-.137M22.86 15.371s.296-.628.61-.7c.315-.073.369.195.369.195M22.975 14.783s-.014-.913.285-.982c.299-.069.399.366.399.366M22.9 14.799s-.09-.765-.474-.676M26.7 15.802s.241-1.114.93-1.114c.689 0 .997 1.177.997 1.177",
      stroke: "#2A8E51",
      strokeWidth: 0.7
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M26.13 15.042s.372-.658 1.596-.604c1.223.053 1.446.604 1.446.604M25.883 14.205s.672-.832 1.614-.127l.32.127s.32-.943 1.866 0",
      stroke: "#2A8E51",
      strokeWidth: 0.7
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M27.74 16.037s.048-1.04.213-1.325M29.099 18.313s-.618-.29-.803 0c-.185.291-2.413 2.962-2.413 2.962",
      stroke: "#964C36"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.965 18.595l1.38.965s.636-.453.318-.71c-.317-.255-1.183-.706-1.183-.706l-.515.45z",
      fill: "#FFF203"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.916 18.645s-.32.334-.32.59c0 .256-.297.942-.297.942s.832.513 1.005.186c.173-.326 1.296-.13 1.098-.63-.199-.498-1.486-1.088-1.486-1.088z",
      fill: "#00A651"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.056 11.182s.738-.379 1.103 0c.365.378.664-.032.664-.26s.58-1.011.58-.376c0 .636-.181.995.328.995.51 0 2.803-.878 3.353-.619.55.26.971.195.832-.177-.14-.373-.5-.605-1.192-.402-.692.203-.528.402-1.126.402-.598 0-1.264-.199-1.264-.199s.187-.334.87-.096c.683.237 1.624-.294 1.88-.294.256 0 .961-.016 1.031.187.07.203.496.39.171.58-.324.189-.86.307-.491.55.368.243 1.215.196 1.255.449.041.252.442.63.281.63-.16 0-.452.355-.723.247-.27-.108-.303-.203-.043-.291.26-.088.258-.457.043-.457-.214 0-.11.13-.597 0-.488-.13-1.134-.273-1.095 0 .039.273.356.692-.23.748-.586.056-.86.28-.974.1-.114-.181-.522-.422-.201-.499.32-.077.627.262.742.207.116-.055.377-.086.158-.321-.22-.235-.58-.373-.245-.549.335-.176.07-.18-.568.185-.639.364-.994.673-1.554.63-.56-.044-.77.015-.951-.044-.18-.06-1.058.652-1.31.472-.253-.181-1.069-.25-.922-.472.147-.222.344-.336.564-.222.22.114.438.229.586.114.148-.114.575-.506.468-.584-.108-.079-.004-.343-.613-.343s-.823.294-.967.11c-.145-.186.157-.401.157-.401z",
      fill: "#FFD100"
    }
  )), /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FJ_svg__d",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#FJ_svg__d)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "FJ_svg__e",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#FJ_svg__e)"
    }
  ))))
);
export {
  t as default
};
